// Shared form-field validators (react-final-form `validate` functions: return an error message, or undefined when valid).

// Moved out of EnquiryFormDrawer unchanged so other forms can reuse it.
export const validateUrl = (value: string) => {

    if (!value) {
        return undefined;
    }

    const urlPattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return urlPattern.test(value) ? undefined : 'Invalid URL';
};
